mtl.alloy.factory['seo-pagination'] = (function($) {
  'use strict';

  return function(element, options) {

    var $element = $(element);
    var $pageLinks = $element.find('.seo-pagination__link');

    var params = new URLSearchParams(window.location.search);
    var activePage = params.get('p');

    $pageLinks.each(function() {
      $(this).removeClass('active');

      if ($(this).text() === activePage) {
        $(this).addClass('active');
      }
    });

    if (activePage === null) {
      $pageLinks.first().addClass('active');
    }

  };

}($));

